module.exports = __webpack_public_path__ + "images/arr-bottom-violet.svg?c3bb16b13d0b9f6ac06bb1f2c9348619";